export default "/WebApp/dist/assets/svg/black-user.svg";